import { DefaultImage } from "assets/svgs";
import { Image } from "components";
import usePostImage from "hooks/usePostImage";
import { useEffect } from "react";
import {
  Control,
  Controller,
  FieldPath,
  UseFormSetValue,
} from "react-hook-form";
import { useAppSelector } from "store/storeHooks";
import { TRules } from "types/form.types";

import { ImageInputStyled } from "./ImageInput.style";
import { CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
interface IImageProps<FormNames extends Record<string, any>> {
  title?: string;
  // description?: string;
  rules?: TRules<FormNames>;
  control: Control<FormNames>;
  name: FieldPath<FormNames>;
  setValue: UseFormSetValue<FormNames>;
  className?: string;
  getUrl?: (url: string) => void;
}
function ImageInput<FormNames extends Record<string, any>>({
  title,
  // description,
  control,
  name,
  setValue,
  rules = {
    required: {
      value: true,
      message: "Rasm yuklash majburiy",
    },
  },
  className,
  getUrl,
}: IImageProps<FormNames>) {
  const isOpen = useAppSelector((store) => store.formDrawerState.isOpen);
  useEffect(() => {
    if (!isOpen) {
      // @ts-ignore
      setValue(name, undefined);
    }
  }, [isOpen]);

  const { uploadImage, imageFile, isUploading } = usePostImage((IDImage) => {
    // @ts-ignore
    setValue(name, IDImage.imageName);
    if (getUrl) {
      getUrl(IDImage.imageName);
    }
  });

  const { t } = useTranslation();
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ fieldState, field }) => {
        return (
          <ImageInputStyled className={className}>
            <h3>{title}</h3>
            <div className="image-main">
              {isUploading ? (
                <div className="pre-loader">
                  <CircularProgress color="success" />
                </div>
              ) : field?.value ? (
                <div className="just-image">
                  <Image src={field?.value} />
                </div>
              ) : (
                <div className="image-top">
                  <DefaultImage />
                </div>
              )}
              {/* <div className="image-bottom">{description}</div> */}
            </div>
            <label className="input-file">
              {/* <span className="input-file-text" type="text"></span> */}
              <input
                // {...field}
                ref={field.ref}
                // value={imageFile?.imageName}
                id={name}
                name={field.name}
                onChange={(e) => {
                  if (e.target.files?.[0]) {
                    uploadImage({
                      imageFile: e.target.files[0],
                      id: name,
                    });
                  }
                  // field.onChange();
                }}
                type="file"
                accept="image/*"
              />
              <span className="input-file-btn">{t("LABELS.SELECT_IMG")}</span>
            </label>
            {fieldState.error && !imageFile && (
              <>
                <h6 className="text-error mt-1">{fieldState.error?.message}</h6>
              </>
            )}
          </ImageInputStyled>
        );
      }}
    />
  );
}

export default ImageInput;
